import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryVariables, StaleTime } from 'queries/types';
import { TICKETS_PREFIX } from 'restful/tickets/constants';
import { restCall } from 'services/api/restful/client';
import { RestApiError } from 'services/api/restful/errors';
import type { TransferByShareCode } from 'services/api/restful/generated/nofomoRestApi.schemas';
import { getTransferByShareCode } from 'services/api/restful/generated/tickets/tickets';

type TransferByShareCodeQueryData = {
  transferByShareCode?: TransferByShareCode;
};

const transferByShareCodeQuery = (variables: { shareCode: string }) =>
  queryOptions<TransferByShareCodeQueryData, RestApiError>({
    queryKey: [TICKETS_PREFIX, 'transfer-by-shareCode', variables],
    queryFn: async () => {
      const { data } = await restCall(() =>
        getTransferByShareCode(variables.shareCode),
      );

      return {
        transferByShareCode: data,
      };
    },
  });

export const useTransferByShareCode = (
  variables: QueryVariables<typeof transferByShareCodeQuery>,
  config?: Partial<ReturnType<typeof transferByShareCodeQuery>>,
) => {
  const { data, isError, isPending } = useQuery({
    ...transferByShareCodeQuery(variables),
    staleTime: StaleTime.FOREVER,
    enabled: !!variables.shareCode,
    retry: false,
    ...config,
  });

  return { transfer: data?.transferByShareCode, isError, isPending };
};
